export default {"src":"/_next/static/media/wallet-solid.6cdeca29.svg","height":24,"width":24};